import React from 'react';
import PoemItem from './PoemItem';
import { Row, Col } from 'react-bootstrap';
import poemsData from '../assets/data/poemsData.json';

function PoemList() {
  // Функция для создания уникального заголовка
  const createUniqueTitle = (title, text) => {
    if (title === '***') {
      // Берем первые 30 символов текста и добавляем "..."
      const preview = text.trim().split('\n')[0].substring(0, 30); // Берем первую строку, и первые 30 символов
      return `${title} (${preview}... )`;
    }
    return title;
  };

  return (
    <Row>
      <h1>Стихи</h1>
      {poemsData.map((poem, index) => (
        <Col md={6} lg={4} key={index}>
          {/* Используем функцию createUniqueTitle */}
          <PoemItem title={createUniqueTitle(poem.title, poem.text)} text={poem.text} />
        </Col>
      ))}
    </Row>
  );
}

export default PoemList;